import { useAppSelector } from 'app/hooks';
import { getActiveCropNominalWeight } from 'current/currentSelectors';
import { getSelectedDataSet } from '../../utils';
import { ChartDataSets, DropdownState } from '../types';
import { FieldData } from 'create/bulk/common/types';
import { useMemo } from 'react';

export const useDatasets = ({
  fields,
  hybrid1,
  hybrid2,
  fieldId,
}: {
  fields: FieldData[];
  hybrid1: DropdownState;
  hybrid2: DropdownState | null;
  fieldId: FieldData['id'];
}) => {
  const cropNominalWeight = useAppSelector(getActiveCropNominalWeight);
  const dataset = useMemo(() => {
    const set = [getSelectedDataSet({ hybrid: hybrid1, fields, fieldId, cropNominalWeight })];

    if (hybrid2) set.push(getSelectedDataSet({ hybrid: hybrid2, fields, fieldId, cropNominalWeight }));

    return set.filter(Boolean) as ChartDataSets[];
  },
  [hybrid1, hybrid2, fields, fieldId, cropNominalWeight]);


  return dataset;
};